// local
// actions
import { pending, rejected, fulfilled } from './async';
import dispatchError from './error';
import { showSnackbar } from './snackbar';
// api
import Client from 'app/api/client';
// consts
import { STATUS as CLIENT_STATUS } from 'salvus-shared/consts/client';

export const list = () => dispatch => {
    dispatch(pending('CLIENT_LIST'));
    Client.list()
        .then(payload => dispatch(fulfilled('CLIENT_LIST', payload)))
        .catch(err => {
            dispatch(rejected('CLIENT_LIST', err));
            dispatchError(dispatch, err);
        });
};

export const create = data => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Client.create(data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'CLIENT_LIST_CREATE', payload });
            dispatch(showSnackbar({ title: `O cliente ${payload.name} foi adicionado com sucesso!`, action: true }));
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const update = (id, data) => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Client.update(id, data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'CLIENT_LIST_UPDATE', payload });
            dispatch(showSnackbar({ title: 'As alterações realizadas foram salvas.', action: true }));
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const updateStatus = (id, data) => dispatch => {
    dispatch(pending('CLIENT_LIST'));
    Client.updateStatus(id, data)
        .then(payload => {
            dispatch({ type: 'CLIENT_LIST_UPDATE', payload });
            if (data.status === CLIENT_STATUS.ENABLED) {
                if (data.oldStatus === CLIENT_STATUS.NEW) {
                    dispatch(showSnackbar({ title: `O cliente ${payload.name} foi ativado com sucesso!`, action: true }));
                } else {
                    dispatch(showSnackbar({ title: `O cliente ${payload.name} foi reativado com sucesso!`, action: true }));
                }
            } else {
                dispatch(showSnackbar({ title: `O cliente ${payload.name} foi desativado.`, action: true }));
            }
        })
        .catch(err => {
            dispatch(rejected('CLIENT_LIST', err));
            dispatchError(dispatch, err, false);
        });
};

export const search = term => ({
    type: 'CLIENT_LIST_SEARCH',
    payload: term,
});

export const reset = () => ({
    type: 'CLIENT_LIST_RESET',
});
